import Button from '@material-ui/core/Button';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import * as React from 'react';

interface MenuDisplaySectionHeaderButtonProps {
  displayed: boolean;
  editMode: boolean;
  onClick: Function;
}

export class MenuDisplaySectionHeaderButton extends React.Component<
  MenuDisplaySectionHeaderButtonProps
> {
  public render(): JSX.Element {
    const { displayed, editMode, onClick } = this.props;

    if (!editMode) {
      return null;
    } else if (displayed) {
      return (
        <Button
          title="Menu section links are shown."
          className="menu__section-links__control"
          onClick={() => onClick(false)}
        >
          <VisibilityIcon className="portal-gray" />
        </Button>
      );
    }

    return (
      <Button
        title="Menu section links are hidden."
        className="menu__section-links__control"
        onClick={() => onClick(true)}
      >
        <VisibilityOffIcon className="portal-gray" />
      </Button>
    );
  }
}

export default MenuDisplaySectionHeaderButton;
